<template>
    <div v-if="loading" :class="['a-cover-loading', {fixed: fixed}]">
        <div
            :class="[
                'holder px-6 pb-6 pt-14',
                { 'elevation-5': boundingBox },
                { 'background-visible': boundingBox },
            ]"
        >
            <AonSpinner v-if="showSpinner" :scale="spinnerScale" :color="spinnerColor" />
            <slot name="header"></slot>
            <h5 class="msg mb-4 mt-12">{{ title }}</h5>
            <p class="msg small">{{ message }}</p>
            <slot name="footer"></slot>
        </div>
    </div>

</template>

<script setup>
import AonSpinner from './AonSpinner.vue';

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    message: {
        type: String,
        default: '',
    },
    loading: {
        type: Boolean,
        default: false,
    },
    boundingBox: {
        type: Boolean,
        default: false,
    },
    spinnerColor: {
        type: String,
        default: 'knightsCloak',
    },
    spinnerScale: {
        type: Number,
        default: 0.5,
    },
    fixed: {
        type: Boolean,
        default: false
    },
    showSpinner: {
        type: Boolean,
        default: true
    }
})
</script>

<script>
    export default {
        name: 'AonCoverLoading'
    }
</script>

<style lang="scss">
.a-cover-loading {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);

    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;

    &.fixed {
        position: fixed;
    }

    .holder {
        display: flex;
        justify-content: center;
        align-content: center;
        flex-wrap: wrap;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        background: transparent;

        .msg {
            width: 100%;
            text-align: center;
        }

        &.background-visible {
            background: white !important;
        }
    }
}
</style>
